export function availableCredits(customer: { postCreditsCount: number, subscription: { pastDueAt: Date, quantity: number }, multipass?: boolean, balance?: number}): number {
  if (customer.multipass) {
    return customer.balance
  } else {
    if (!!customer.subscription.pastDueAt) {
      return Math.max(customer.postCreditsCount - customer.subscription.quantity, 0)
    } else {
      return customer.postCreditsCount
    }
  }
}
